import React from 'react';

import moment from 'moment';
import {Image, ScrollView, Text, TouchableOpacity, View} from 'react-native';
import {ButtonGroup, Card} from 'react-native-elements';
import {NavigationEvents, createAppContainer} from 'react-navigation';
import {createStackNavigator} from 'react-navigation-stack';
import {
  eleven_logo,
  images_areia,
  images_churrasqueiras,
  images_padel,
  images_pickleball,
} from './constants.js';

import firebase from 'firebase';
import db from './firebase_app';

const location_list = [
  require('../img/areia.jpeg'),
  require('../img/padel.jpeg'),
  require('../img/pickleball2.jpg'),
  require('../img/churrasqueira.jpeg'),
];
const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

const QUADRAS_AREIA = 10;
const QUADRAS_PADEL = 4;
const QUADRAS_PICKLEBALL = 3;
const CHURRASQUEIRAS = 4;
function formatDate(date, hour) {
  var splitted = date.split('-');
  var year = splitted[0];
  var month = splitted[1];
  var day = splitted[2];

  if (hour === 'Meio-dia' || hour === 'Noite') {
    return (
      day + ' de ' + MONTHS[parseInt(month - 1)] + ' de ' + year + '\n' + hour
    );
  }
  return (
    day +
    ' de ' +
    MONTHS[parseInt(month - 1)] +
    ' de ' +
    year +
    '\nÀs ' +
    hour +
    'h'
  );
}

class FirstScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      areia: [],
      padel: [],
      pickleball: [],
      profile: {},
      churrasqueira: [],
      aulas: [],
      dates: null,
      query_done: false,
      active: 0,
    };

    const {navigate} = this.props.navigation;

    var params = this.props.navigation.state.params;
    var user = firebase.auth().currentUser.uid;
    var cards = this.state.cards;

    var that = this;
    this.buttons = ['Areia', 'Padel', 'Pickleball', 'Churrasqueira'];
    db.ref('/profile/' + user)
      .once('value')
      .then(snapshot => {
        var profile = snapshot.val();
        // this.setState({"profile": profile})
        this.state['profile'] = profile;
        // console.log('Profile:')
        // console.log(profile);
        this.load();
      });
  }

  load() {
    // console.log("HERE");
    const {navigate} = this.props.navigation;

    // var params = this.props.navigation.state.params
    var user = firebase.auth().currentUser.uid;
    // var cards = this.state.cards;
    var areia = {};
    var padel = {};
    var pickleball = {};
    var churrasqueira = {};
    var aulas = [];
    for (var i = 0; i < QUADRAS_AREIA; i++) {
      areia = [];
    }
    for (var i = 0; i < QUADRAS_PADEL; i++) {
      padel = [];
    }
    for (var i = 0; i < QUADRAS_PICKLEBALL; i++) {
      pickleball = [];
    }
    for (var i = 0; i < CHURRASQUEIRAS; i++) {
      churrasqueira = [];
    }
    var that = this;

    this.setState({
      areia: areia,
      padel: padel,
      pickleball: pickleball,
      churrasqueira: churrasqueira,
      aulas: aulas,
    });

    if (
      this.state.profile['professor'] != null &&
      this.state.profile['professor']
    ) {
      db.ref('/professor/' + user)
        .once('value')
        .then(snapshot_prof => {
          this.buttons = [
            'Areia',
            'Padel',
            'Pickleball',
            'Churrasqueira',
            'Aulas',
          ];
          var aulas = [];
          if (snapshot_prof != null && snapshot_prof.val() != null) {
            const aulas_snap = snapshot_prof.val();
            // console.log('aulas_snap: ', aulas_snap)
            var aulas = [];
            var keys = Object.keys(aulas_snap);
            for (const key of keys) {
              var aula = aulas_snap[key];
              aula = aula.split('\\');
              var aula_dict = {
                modality: aula[2],
                date: aula[3],
                hour: aula[4],
                space: aula[5],
                key: key,
              };

              aulas.push(aula_dict);
            }
            console.log('aulas: ', aulas);
            this.setState({aulas: aulas});
          }

          // console.log(this.state["aulas"]);
        });
    }

    for (var i = 0; i < 8; i++) {
      var date = new Date();
      date.setDate(date.getDate() + i);
      // console.log(date);

      const ref_areia = db
        .ref('/schedule/' + 'areia/' + date.toISOString().slice(0, 10))
        .once('value')
        .then(snapshot => {
          var dates = snapshot.val();
          if (dates != null) {
            // console.log('dates')
            // console.log(dates)
            var keys = Object.keys(dates);
            // console.log(keys)
            for (const key of keys) {
              // console.log('spaces')
              var spaces = Object.keys(dates[key]);
              // console.log(spaces)
              for (const space of spaces) {
                if (
                  dates[key][space]['identity'] ===
                  this.state.profile['identity']
                ) {
                  var to_push = [snapshot.key, key, space.split('-')[1]];
                  areia.push(to_push);
                }
              }
            }
            that.setState({areia: areia});
          }
        });
      const ref_padel = db
        .ref('/schedule/' + 'padel/' + date.toISOString().slice(0, 10))
        .once('value')
        .then(snapshot => {
          var dates = snapshot.val();
          if (dates != null) {
            var keys = Object.keys(dates);
            for (const key of keys) {
              var spaces = Object.keys(dates[key]);
              for (const space of spaces) {
                if (
                  dates[key][space]['identity'] ===
                  this.state.profile['identity']
                ) {
                  var to_push = [snapshot.key, key, space.split('-')[1]];
                  padel.push(to_push);
                }
              }
            }
            that.setState({padel: padel});
          }
        });
      const ref_pickleball = db
        .ref('/schedule/' + 'pickleball/' + date.toISOString().slice(0, 10))
        .once('value')
        .then(snapshot => {
          var dates = snapshot.val();
          if (dates != null) {
            var keys = Object.keys(dates);
            for (const key of keys) {
              var spaces = Object.keys(dates[key]);
              for (const space of spaces) {
                if (
                  dates[key][space]['identity'] ===
                  this.state.profile['identity']
                ) {
                  var to_push = [snapshot.key, key, space.split('-')[1]];
                  pickleball.push(to_push);
                }
              }
            }
            that.setState({pickleball: pickleball});
          }
        });
      const ref_churrasqueira = db
        .ref('/schedule/' + 'churrasqueira/' + date.toISOString().slice(0, 10))
        .once('value')
        .then(snapshot => {
          var dates = snapshot.val();
          if (dates != null) {
            var keys = Object.keys(dates);
            for (const key of keys) {
              var spaces = Object.keys(dates[key]);
              for (const space of spaces) {
                if (
                  dates[key][space]['identity'] ===
                  this.state.profile['identity']
                ) {
                  var to_push = [snapshot.key, key, space.split('-')[1]];
                  churrasqueira.push(to_push);
                }
              }
            }
            that.setState({churrasqueira: churrasqueira});
          }
        });
    }
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  render() {
    var query_done = this.state.query_done;
    var areia = this.state.areia;
    var padel = this.state.padel;
    var pickleball = this.state.pickleball;
    var churrasqueira = this.state.churrasqueira;
    var aulas = this.state.aulas;
    var dates = this.state.dates;
    var params = this.props.navigation.state.params;
    const {navigate} = this.props.navigation;
    var that = this;

    return (
      <ScrollView contentContainerStyle={{backgroundColor: '#f7f7f7'}}>
        <NavigationEvents
          onWillFocus={payload => {
            this.load();
          }}
        />
        <ButtonGroup
          onPress={active => this.setState({active})}
          selectedIndex={this.state.active}
          buttons={this.buttons}
          textStyle={{fontSize: 12}}
          containerStyle={{
            padding: 0,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            marginBottom: 0,
            height: 50,
          }}
          underlayColor="#dc812e"
          selectedButtonStyle={{backgroundColor: '#dc812e'}}
        />
        {areia.map((prop, key) => {
          if (this.state.active === 0) {
            return (
              <TouchableOpacity
                key={key}
                onPress={() =>
                  selectedDay(
                    that,
                    navigate,
                    'areia',
                    prop[0],
                    prop[1],
                    prop[2],
                  )
                }>
                <Card
                  image={images_areia[prop[2]]}
                  pointerEvents="none"
                  key={key}>
                  <Text>{formatDate(prop[0], prop[1])}</Text>
                </Card>
              </TouchableOpacity>
            );
          }
        })}
        {[0].map((prop, key) => {
          if (this.state.active === 0 && areia.length === 0) {
            return (
              <View style={{justifyContent: 'center', alignItems: 'center'}}>
                <Image
                  source={eleven_logo[1]}
                  style={{height: 300, width: 300}}
                  resizeMode="center"
                />

                <Text>Você não possui nenhum agendamento desta categoria.</Text>
                <Text>
                  Se algum dos seus agendamentos não estiver aparecendo,
                </Text>
                <Text>experimente reiniciar o aplicativo.</Text>
              </View>
            );
          }
        })}
        {padel.map((prop, key) => {
          if (this.state.active === 1) {
            return (
              <TouchableOpacity
                key={key}
                onPress={() =>
                  selectedDay(
                    that,
                    navigate,
                    'padel',
                    prop[0],
                    prop[1],
                    prop[2],
                  )
                }>
                <Card
                  image={images_padel[prop[2]]}
                  pointerEvents="none"
                  key={key}>
                  <Text>{formatDate(prop[0], prop[1])}</Text>
                </Card>
              </TouchableOpacity>
            );
          }
        })}
        {[0].map((prop, key) => {
          if (this.state.active === 1 && padel.length === 0) {
            return (
              <View style={{justifyContent: 'center', alignItems: 'center'}}>
                <Image
                  source={eleven_logo[1]}
                  style={{height: 300, width: 300}}
                  resizeMode="center"
                />

                <Text>Você não possui nenhum agendamento desta categoria.</Text>
                <Text>
                  Se algum dos seus agendamentos não estiver aparecendo,
                </Text>
                <Text>experimente reiniciar o aplicativo.</Text>
              </View>
            );
          }
        })}
        {pickleball.map((prop, key) => {
          if (this.state.active === 2) {
            return (
              <TouchableOpacity
                key={key}
                onPress={() =>
                  selectedDay(
                    that,
                    navigate,
                    'pickleball',
                    prop[0],
                    prop[1],
                    prop[2],
                  )
                }>
                <Card
                  image={images_pickleball[prop[2]]}
                  pointerEvents="none"
                  key={key}>
                  <Text>{formatDate(prop[0], prop[1])}</Text>
                </Card>
              </TouchableOpacity>
            );
          }
        })}
        {[0].map((prop, key) => {
          if (this.state.active === 2 && pickleball.length === 0) {
            return (
              <View style={{justifyContent: 'center', alignItems: 'center'}}>
                <Image
                  source={eleven_logo[1]}
                  style={{height: 300, width: 300}}
                  resizeMode="center"
                />

                <Text>Você não possui nenhum agendamento desta categoria.</Text>
                <Text>
                  Se algum dos seus agendamentos não estiver aparecendo,
                </Text>
                <Text>experimente reiniciar o aplicativo.</Text>
              </View>
            );
          }
        })}
        {churrasqueira.map((prop, key) => {
          if (this.state.active === 3) {
            return (
              <TouchableOpacity
                key={key}
                onPress={() =>
                  selectedDay(
                    that,
                    navigate,
                    'churrasqueira',
                    prop[0],
                    prop[1],
                    prop[2],
                  )
                }>
                <Card
                  image={images_churrasqueiras[prop[2]]}
                  pointerEvents="none"
                  key={key}>
                  <Text>{formatDate(prop[0], prop[1])}</Text>
                </Card>
              </TouchableOpacity>
            );
          }
        })}
        {[0].map((prop, key) => {
          if (this.state.active === 3 && churrasqueira.length === 0) {
            return (
              <View style={{justifyContent: 'center', alignItems: 'center'}}>
                <Image
                  source={eleven_logo[1]}
                  style={{height: 300, width: 300}}
                  resizeMode="center"
                />

                <Text>Você não possui nenhum agendamento desta categoria.</Text>
                <Text>
                  Se algum dos seus agendamentos não estiver aparecendo,
                </Text>
                <Text>experimente reiniciar o aplicativo.</Text>
              </View>
            );
          }
        })}
        {aulas.map((prop, key) => {
          if (this.state.active === 4) {
            return (
              <TouchableOpacity
                key={key}
                onPress={() =>
                  selectedDay(
                    that,
                    navigate,
                    prop['modality'] + '\\' + prop['key'],
                    prop['date'],
                    prop['hour'],
                    prop['space'].split('-')[1],
                  )
                }>
                <Card
                  title={
                    prop['modality'] +
                    ' - Espaço ' +
                    (parseInt(prop['space'].split('-')[1]) + 1)
                  }
                  pointerEvents="none"
                  key={key}>
                  <Text>{formatDate(prop['date'], prop['hour'])}</Text>
                </Card>
              </TouchableOpacity>
            );
          }
        })}
        {[0].map((prop, key) => {
          if (this.state.active === 4 && aulas.length === 0) {
            return (
              <View style={{justifyContent: 'center', alignItems: 'center'}}>
                <Image
                  source={eleven_logo[1]}
                  style={{height: 300, width: 300}}
                  resizeMode="center"
                />

                <Text>Você não possui nenhum agendamento desta categoria.</Text>
                <Text>
                  Se algum dos seus agendamentos não estiver aparecendo,
                </Text>
                <Text>experimente reiniciar o aplicativo.</Text>
              </View>
            );
          }
        })}
      </ScrollView>
    );
  }
}

function selectedDay(that, navigate, location, day, hour, space) {
  // console.log(hour)
  var alert_string = formatDate(day, hour);
  // var alert_string = day + " " + hour.toString() + "-" + (parseInt(hour)+1).toString() + "h"
  // if (location === "churrasqueira") {
  //   alert_string = day + " " + hour.toString()
  // }

  const res = confirm('Deseja desmarcar este horário?');
  if (res) {
    removeAndNavigate(that, navigate, location, day, hour, space);
  } else {
    console.log('Cancel pressed');
  }
  // Alert.alert(
  //   alert_string,
  //   'Deseja desmarcar este horário?',
  //   [
  //     {
  //       text: 'Cancel',
  //       onPress: () => console.log('Cancel Pressed'),
  //       style: 'cancel',
  //     },
  //     {text: 'OK', onPress: () => removeAndNavigate(that, navigate, location, day, hour, space)},
  //   ]
  // );
}

function removeAndNavigate(that, navigate, location, day, hour, space) {
  var user = firebase.auth().currentUser.uid;
  console.log('info');
  console.log('esporte', location);
  console.log('dia', day);
  console.log('hora', hour);
  console.log('quadra', space);
  var test = moment(day + 'T' + ('0' + hour).slice(-2) + ':00:00');
  var now = moment();
  var diff = test.diff(now, 'hours');

  console.log(test.format('YYYY-MM-DD/HH'));
  console.log(now.format('YYYY-MM-DD/HH'));
  console.log('diferenca', diff);
  console.log('remove');
  db.ref('/profile/' + user)
    .once('value')
    .then(snapshot => {
      var profile = snapshot.val();
      db.ref(
        '/schedule/' +
          location +
          '/' +
          day +
          '/' +
          hour.toString() +
          '/space-' +
          space,
      )
        .once('value')
        .then(snapshot => {
          const val = snapshot.val();
          if (val['date']) {
            const scheduled_date = moment(val['date']);
            const min_diff = now.diff(scheduled_date, 'minutes');
            if (min_diff <= 15) {
              console.log('min diff ok');
              console.log(min_diff);
              // Não altere o valor de diff aqui
            }
          }
          if (diff < 12) {
            alert(
              'Faltam menos de 12 horas.\nNão é possível desmarcar esse agendamento.\n\nEntre em contato com (53) 9176-2332.',
            );
          } else {
            var aulas_key = null;
            if (location.includes('\\')) {
              const location_aux = location.split(/\\/);
              location = location_aux[0];
              aulas_key = location_aux[1];
              console.log('Aulas key: ', aulas_key);
            }
            if (aulas_key != null) {
              var user = firebase.auth().currentUser.uid;
              console.log(
                'to remove: ',
                '/professor/' + user + '/' + aulas_key,
              );
              db.ref('/professor/' + user + '/' + aulas_key).remove();
            }
            console.log(
              '/schedule/' + location + '/' + day + '/' + hour.toString(),
            );
            db.ref(
              '/schedule/' +
                location +
                '/' +
                day +
                '/' +
                hour.toString() +
                '/space-' +
                space,
            )
              .remove()
              .then(
                logMovimentacao(
                  'delete',
                  day,
                  location,
                  parseInt(space) + 1,
                  hour,
                  profile['name'],
                  dataFormatada(),
                  profile['name'],
                  'aplicativo',
                ),
              );
            console.log('removed');
            that.load();
            navigate('First');
          }
        });
    });
}

/* Start Função log*/
function dataFormatada(diaQuadra) {
  if (diaQuadra) {
    let data = new Date(diaQuadra),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(),
      mesF = mes.length == 1 ? '0' + mes : mes,
      anoF = data.getFullYear();
    let completeData = `${diaF}-${mesF}-${anoF}`;
    return completeData;
  } else {
    let data = new Date(),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? '0' + mes : mes,
      anoF = data.getFullYear();
    let completeData = `${diaF}-${mesF}-${anoF}`;
    return completeData;
  }
}

function horaAtualFormatada() {
  let data = new Date(),
    hora = data.getHours().toString(),
    horaF = hora.length == 1 ? '0' + hora : hora,
    minuto = data.getMinutes().toString(),
    minutoF = minuto.length == 1 ? '0' + minuto : minuto,
    segundo = data.getSeconds().toString(),
    segundoF = segundo.length == 1 ? '0' + segundo : segundo;

  let completeHour = `${horaF}-${minutoF}-${segundoF}`;
  return completeHour;
}

function testeThen() {
  console.log('then funciona');
}
function logMovimentacao(
  type,
  dataMarcada,
  modalityb,
  spaceb,
  hourb,
  name,
  dataN,
  registered_by,
  origin,
) {
  console.log('spaceb', spaceb);
  const dateString = dataMarcada.split('-');
  const dataMarcadaN = `${dateString[2]}-${dateString[1]}-${dateString[0]}`;

  const horas = horaAtualFormatada();
  db.ref(
    `/log/${modalityb}/${spaceb}/${hourb}/${dataMarcadaN}/${type}/${dataN}/${horas}`,
  )
    .once('value')
    .then(snapshot2 => {
      console.log('entrei aqui');
      console.log('snapshot2', snapshot2);
      if (!snapshot2.val()) {
        db.ref(
          `/log/${modalityb}/${spaceb}/${hourb}/${dataMarcadaN}/${type}/${dataN}/${horas}`,
        ).set({
          // type: `${type}`,
          action: `${registered_by} ${
            type == 'new'
              ? `marcou para o dia ${dataMarcadaN} a quadra ${spaceb} de ${modalityb} no horário ${hourb} para ${name}, no dia ${dataN} as ${horas} ${
                  origin == 'interno'
                    ? 'pelo sistema interno'
                    : 'pelo aplicativo'
                }`
              : `desmarcou a a quadra ${spaceb} de ${modalityb} do dia ${dataMarcadaN} as ${hourb} para ${name}, no dia ${dataN} as ${horas} ${
                  origin == 'interno'
                    ? 'pelo sistema interno'
                    : 'pelo aplicativo'
                }`
          }`,
        });
      } else {
        alert(
          'Alguém acabou de marcar neste mesmo horário. Atualize sua visualização.',
        );
      }
    });
}
/* End função log */

// class JumpScreen extends React.Component {
//   constructor(props) {
//       super(props);
//       const {navigate} = this.props.navigation;
//       navigate('First');
//   }
// }
const AgendadoNavigator = createStackNavigator({
  First: {screen: FirstScreen},
});

const AgendadoContainer = createAppContainer(AgendadoNavigator);

export default AgendadoContainer;
